import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden rounded-full font-bold text-mystic-900 
        bg-gradient-to-r from-gold-light via-gold to-gold-dark
        shadow-[0_0_20px_rgba(212,168,83,0.4)] hover:shadow-[0_0_30px_rgba(240,198,116,0.6)]
        transition-all duration-300 px-8 py-4 text-lg tracking-wide uppercase
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-38">
      {/* Subtle shine effect overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:animate-[shimmer_1.5s_infinite]" data-id="element-39" />
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-40">
        {children}
      </span>
    </motion.button>;
}